/**
 * @desc 批量新增操作日志
 */
const URL = "/rantion-aider";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.aider.OperationLogParamDto>, options?: any) {
  return updateResponse(
    http(URL + `/log/operation/batchAdd`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
